import {
  Card,
  CardContent,
  CardActionArea,
  Typography,
  styled,
  Stack
} from '@mui/material';

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  border: `1px solid #009FE333`,
  backgroundColor: theme.colors.primary.light,
  boxShadow: '0px 0px 8px 0px #0000001A'
}));

interface IProps {
  description: string;
  onClick: () => void;
  icon?: React.ReactNode;
}

const TopicCard = ({ description, onClick, icon }: IProps) => {
  return (
    <StyledCard sx={{ flex: 1 }}>
      <CardActionArea onClick={onClick}>
        <CardContent>
          <Stack direction="row" gap={1} alignItems="center">
            {icon && icon}
            <Typography variant="body1" fontSize="12px" textAlign="center">
              {description}
            </Typography>
          </Stack>
        </CardContent>
      </CardActionArea>
    </StyledCard>
  );
};

export default TopicCard;
